import { Injectable } from '@angular/core';
import { IFileControlHelper } from './file.service';
import { FormGroup } from '@angular/forms';

@Injectable()
export class FileControlHelper implements IFileControlHelper {
  fillFileControls(formGroup: FormGroup, file: File, callback?: () => void) {
    formGroup.controls['data'].setValue(file); // fill 'data'
    if (file) {
      const reader = new FileReader();
      reader.onload = _event => {
        formGroup.controls['src'].setValue(reader.result); // fill 'src'
        if (callback) callback();
      };
      reader.readAsDataURL(file);
    }
  }
}
